import { Avatar } from '../common';
import type { BookingDetail, Owner } from './types';

/**
 * The household's own avatar beside a value they gave us.
 *
 * READ FROM `dogs.confirmed_by`, which is the same key the household modal
 * reads — that is what makes the two screens agree by construction rather than
 * by two implementations being kept in step by hand (desk-sees-customer-answers,
 * migration 0033).
 *
 * The contact's OWN face, not a generic portal glyph: on a household where two
 * people registered, which of them answered is the thing worth knowing.
 */
export function DogMark({ by, owner }: { by?: number; owner: Owner }) {
  if (by == null) return null;
  const who = owner.contacts.find((c) => c.id === by);
  const name = who?.name?.trim() || 'The household';
  return (
    // Named for a screen reader too: a tooltip alone announces nothing.
    <span className="cust-mark" title={`${name} gave us this`} role="img" aria-label={`${name} gave us this`}>
      <Avatar name={name} id={String(by)} size={18} />
    </span>
  );
}
